
import { Row } from 'antd'

import { LeadModel } from '@/typings/models/Lead'
import EditableTextField from '@/components/Lead/EditableTextField'
import PhoneNumberFormat from '@/components/format/PhoneNumberFormat'

const getLeadPhone = (lead: LeadModel) => lead?.customer?.phone;

const CustomerPhone = ({
  lead,
  readonly,
  isTable,
}: {
  lead: LeadModel;
  readonly: boolean;
  isTable: boolean;
  showOnePhone?: boolean;
}) => {
  const phone = getLeadPhone(lead);
  return (
    <Row>
      <EditableTextField isTable={isTable} editable={false} lead={lead} property={'customer.phone'}>
        <PhoneNumberFormat phoneNumber={phone} variant="link" />
      </EditableTextField>
    </Row>
  );
};

export default CustomerPhone;
